import { render, staticRenderFns } from "./WorkPermitView.vue?vue&type=template&id=c697308c&scoped=true&"
import script from "./WorkPermitView.vue?vue&type=script&lang=js&"
export * from "./WorkPermitView.vue?vue&type=script&lang=js&"
import style0 from "styles/table.scss?vue&type=style&index=0&id=c697308c&lang=scss&scoped=true&"
import style1 from "./WorkPermitView.vue?vue&type=style&index=1&id=c697308c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c697308c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c697308c')) {
      api.createRecord('c697308c', component.options)
    } else {
      api.reload('c697308c', component.options)
    }
    module.hot.accept("./WorkPermitView.vue?vue&type=template&id=c697308c&scoped=true&", function () {
      api.rerender('c697308c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WorkPermitView.vue"
export default component.exports